import usePayment from 'attendee/Billing/Payments/usePayment'
import {EventModel} from 'event/models/Event'
import {useLocalizedNavigate} from 'i18n/useLocalizedNavigate'
import {routes} from 'routes/routes'

export default function useTicketPayment(
  event: EventModel | null,
  eventTicketId: number | null,
) {
  const {newPayment} = usePayment()
  const navigate = useLocalizedNavigate()

  const onSuccess = () => {
    navigate(routes.tickets)
  }

  const payment = () => {
    if (!event?.id || eventTicketId == null) {
      throw new Error('Missing event or ticket selection')
    }
    return newPayment(
      `api/payment/event/${event.id}/buy-ticket`,
      `api/payment/event/${event.id}/ticket-confirmation`,
      {eventTicketId},
      onSuccess,
    )
  }

  return {
    payment,
  }
}
